"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerContextMenu = void 0;
var i18n_1 = require("../../localization/i18n");
var version_1 = require("../../version");
var Label_1 = require("../labels/Label");
var ContextMenu_1 = require("./ContextMenu");
var PlayerInsightsContextMenuItem_1 = require("../panels/player-insights/PlayerInsightsContextMenuItem");
var SettingsPanelItem_1 = require("../settings/SettingsPanelItem");
var SettingsPanelPage_1 = require("../settings/SettingsPanelPage");
var SettingsPanelSeparator_1 = require("../settings/SettingsPanelSeparator");
/**
 * A player-specific context menu with Bitmovin info and Player/UI versions.
 *
 * @category Components
 */
var PlayerContextMenu = /** @class */ (function (_super) {
    __extends(PlayerContextMenu, _super);
    function PlayerContextMenu(config) {
        var _a, _b;
        var actionItems = __spreadArray([
            new PlayerInsightsContextMenuItem_1.PlayerInsightsContextMenuItem({
                playerInsightsPanel: config.playerInsightsPanel,
            })
        ], ((_a = config.components) !== null && _a !== void 0 ? _a : []), true);
        return _super.call(this, __assign(__assign({}, config), { cssClasses: __spreadArray(['ui-player-context-menu'], ((_b = config.cssClasses) !== null && _b !== void 0 ? _b : []), true), components: [
                new SettingsPanelPage_1.SettingsPanelPage({
                    components: __spreadArray([new PlayerInfoContextMenuItem(), new SettingsPanelSeparator_1.SettingsPanelSeparator()], actionItems, true),
                }),
            ] })) || this;
    }
    return PlayerContextMenu;
}(ContextMenu_1.ContextMenu));
exports.PlayerContextMenu = PlayerContextMenu;
var PlayerInfoContextMenuItem = /** @class */ (function (_super) {
    __extends(PlayerInfoContextMenuItem, _super);
    function PlayerInfoContextMenuItem() {
        var _this = this;
        var playerVersionLabel = new Label_1.Label({
            text: 'Player: -',
            cssClasses: ['ui-player-context-menu-info'],
        });
        _this = _super.call(this, {
            label: null,
            components: [
                new Label_1.Label({
                    text: i18n_1.i18n.getLocalizer('contextMenu.title'),
                    cssClasses: ['ui-player-context-menu-header'],
                }),
                new Label_1.Label({
                    text: i18n_1.i18n.getLocalizer('contextMenu.subtitle'),
                    cssClasses: ['ui-player-context-menu-subtitle'],
                }),
                playerVersionLabel,
                new Label_1.Label({
                    text: "UI: ".concat(version_1.version),
                    cssClasses: ['ui-player-context-menu-info'],
                }),
            ],
            cssClasses: ['ui-player-context-menu-info-item'],
            isSetting: false,
            role: 'group',
            tabIndex: -1,
        }) || this;
        _this.playerVersionLabel = playerVersionLabel;
        return _this;
    }
    PlayerInfoContextMenuItem.prototype.configure = function (player, uimanager) {
        _super.prototype.configure.call(this, player, uimanager);
        this.playerVersionLabel.setText("Player: ".concat(player.version));
    };
    return PlayerInfoContextMenuItem;
}(SettingsPanelItem_1.SettingsPanelItem));
